var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHome = function SvgIconHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.268 1.207a1.2 1.2 0 0 1 1.473 0l10.8 8.4a1.2 1.2 0 0 1 .464.947v13.2a3.6 3.6 0 0 1-3.6 3.6h-16.8a3.6 3.6 0 0 1-3.6-3.6v-13.2c0-.37.17-.72.463-.947zm-8.863 9.934v12.613a1.2 1.2 0 0 0 1.2 1.2h16.8a1.2 1.2 0 0 0 1.2-1.2V11.141l-9.6-7.466z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.205 14.154a1.2 1.2 0 0 1 1.2-1.2h7.2a1.2 1.2 0 0 1 1.2 1.2v12a1.2 1.2 0 0 1-2.4 0v-10.8h-4.8v10.8a1.2 1.2 0 0 1-2.4 0z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHome;